import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

/**
 * Internal Formly FieldType Component
 * Used internally by RadioWrapperComponent and Formly forms.
 * Do not use this directly - use RadioWrapperComponent instead.
 */
@Component({
  selector: 'era-formly-radio-field',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, ReactiveFormsModule, FormlyModule],
})
export class RadioComponent extends FieldType<FieldTypeConfig> {
  get required(): boolean {
    return this.props.required || false;
  }

  get disabled(): boolean {
    return this.props.disabled || false;
  }

  get radioOptions(): { label: string; value: unknown }[] {
    return (this.props.options as { label: string; value: unknown }[]) || [];
  }

  get labelPosition(): 'left' | 'right' {
    return this.props.labelPosition || 'right';
  }

  get labelWidth(): string | undefined {
    return this.props.labelWidth;
  }
}
